import React from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  TextField,
  Select, 
  MenuItem,
  FormControl
} from '@mui/material';

export const Measurements = ({ value, onChange, editMode = false }) => {
  const { width, widthUnit, length, lengthUnit } = value || { width: '', widthUnit: 'in', length: '', lengthUnit: 'in' };

  const convertToInches = (val, unit) => {
    if (!val) return '';
    if (unit === 'cm') return (parseFloat(val) / 2.54).toFixed(2);
    return val;
  };

  const convertToCm = (val, unit) => {
    if (!val) return '';
    if (unit === 'in') return (parseFloat(val) * 2.54).toFixed(1);
    return Math.round(parseFloat(val));
  };

  if (editMode) {
    return (
      <Box my={2}>
        <Typography variant="h6" gutterBottom>Measurements</Typography>
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <TextField
              label="Width"
              type="number"
              value={width || ''}
              onChange={(e) => 
                onChange('measurements', { 
                  ...value, 
                  width: e.target.value,
                  convertedWidth: convertToInches(e.target.value, widthUnit)
                })
              }
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
            <FormControl size="small" variant="outlined">
              <Select
                value={widthUnit}
                onChange={(e) => 
                  onChange('measurements', { 
                    ...value, 
                    widthUnit: e.target.value,
                    convertedWidth: convertToInches(width, e.target.value)
                  })
                }
                size="small"
                sx={{ minWidth: 60 }}
              >
                <MenuItem value="in">in</MenuItem>
                <MenuItem value="cm">cm</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Length"
              type="number"
              value={length || ''}
              onChange={(e) => 
                onChange('measurements', { 
                  ...value, 
                  length: e.target.value,
                  convertedLength: convertToInches(e.target.value, lengthUnit)
                })
              }
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
            <FormControl size="small" variant="outlined">
              <Select
                value={lengthUnit}
                onChange={(e) => 
                  onChange('measurements', { 
                    ...value, 
                    lengthUnit: e.target.value,
                    convertedLength: convertToInches(length, e.target.value)
                  })
                }
                size="small"
                sx={{ minWidth: 60 }}
              >
                <MenuItem value="in">in</MenuItem>
                <MenuItem value="cm">cm</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    );
  }

  const displayWidth = widthUnit === 'in' ? width : convertToInches(width, 'cm');
  const displayLength = lengthUnit === 'in' ? length : convertToInches(length, 'cm');
  const displayWidthCm = widthUnit === 'cm' ? Math.round(width) : convertToCm(width, 'in');
  const displayLengthCm = lengthUnit === 'cm' ? Math.round(length) : convertToCm(length, 'in');

  return (
    <Box my={2}>
      <Typography variant="h6" gutterBottom>Finished Measurements</Typography>
      <Typography>
        {displayWidth}" × {displayLength}" ({displayWidthCm}cm × {displayLengthCm}cm)
      </Typography>
    </Box>
  );
};

export default Measurements;
